import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { type MqttUser, type MqttUserWithPassword, type UpdateMqttUser } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MqttUsersService {
  private http = inject(HttpClient);

  list() {
    return this.http.get<{ data: MqttUser[]; }>('clients/v1/mqtt-users');
  }

  update(id: string, data: Partial<UpdateMqttUser>) {
    return this.http.patch<MqttUserWithPassword>(`clients/v1/mqtt-users/${id}`, data);
  }

  delete(id: string) {
    return this.http.delete<MqttUser>(`clients/v1/mqtt-users/${id}`);
  }

  create(deviceId: string) {
    return this.http.post<MqttUserWithPassword>('clients/v1/mqtt-users', { deviceId });
  }

  details(id: string) {
    return this.http.get<MqttUser>(`clients/v1/mqtt-users/${id}`);
  }
}
